import React from 'react'
import Livescore from '../components/ls/Livescore'
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {Link} from "react-router-dom";

class Yesterday extends React.Component{

   constructor(props){
      super(props)
      this.state = {
         date : null
      }
   }

   componentDidMount(){
      this.setState({date : new Date(Date.now() + (3600000*7) - (3600000*24)).toISOString().slice(0,10)})
   }
   
    render() {
        return (
         this.state.date!==null?
         <HelmetProvider>
         
            <Helmet>
            <title>ผลบอลเมื่อคืน ผลบอลย้อนหลัง เช็คผลบอล สรุปสกอร์ โปรแกรมบอลเมื่อคืนนี้</title>
            <meta name="description" content="ทราบทุกสกอร์บอลของโปรแกรมบอลเมื่อคืนที่ผ่านมา ผลบอลเมื่อคืน ตารางบอลเมื่อวานนี้ เช็คผลบอลล่าสุดทุกลีก ข้อมูลแน่น ครบถ้วนที่สุด รู้รายงานการแข่งขันทุกคู่ในเว็บเดียว" />
            <link rel="canonical" href="https://mvpkick.com/ผลบอลเมื่อคืน/" />
            <meta property="og:url" content="https://mvpkick.com/ผลบอลเมื่อคืน/" />
            <meta property="og:title" content="ผลบอลเมื่อคืน ผลบอลย้อนหลัง เช็คผลบอล สรุปสกอร์ โปรแกรมบอลเมื่อคืนนี้" />
            <meta property="og:description" content="ทราบทุกสกอร์บอลของโปรแกรมบอลเมื่อคืนที่ผ่านมา ผลบอลเมื่อคืน ตารางบอลเมื่อวานนี้ เช็คผลบอลล่าสุดทุกลีก ข้อมูลแน่น ครบถ้วนที่สุด รู้รายงานการแข่งขันทุกคู่ในเว็บเดียว" />
            <meta property="og:image" content="https://mvpkick.com/img/asset/og-img-main.jpg" />
            </Helmet>
        <div>
               <Livescore selectDate={this.state.date} />
               <div className="boxContentPage">
               <div>
                  <h1>ผลบอลย้อนหลัง ตารางบอลเมื่อคืน ผลบอลเมื่อคืน โปรแกรมบอลเมื่อวาน เช็คผลบอล</h1>
                  <p>สรุปผลบอลเมื่อคืน ผลบอลเมื่อวานนี้ เช็คผลบอลแมนยู ลิเวอร์พูล เชลซี สรุปข้อมูลการแข่งขันฟุตบอลเมื่อคืนที่ผ่านมา อยากรู้รายการไหนใครเป็นผู้ชนะคว้า 3 แต้มไปครอง หรือจบเกมส์ไปแบบเสมอ มาเช็คข้อมูลฟุตบอลผ่านตารางบอลเมื่อวานจากหน้าเว็บไซต์ MVPKICK เว็บเดียวตอบโจทย์ได้ครบเครื่องเรื่องฟุตบอล มีโปรแกรมแข่งครบถ้วน บอลเมื่อคืน ผลบอลสด <Link to="/บอลพรุ่งนี้/">บอลพรุ่งนี้</Link> หากพลาดการรับชมบอลสดๆระหว่างแข่ง สามารถมาเช็คข้อมูลผลบอลย้อนหลังได้ทุกเวลา สามารถดูย้อนหลังของเมื่อคืนที่ผ่านมา และเมื่อวานก่อน รวมเช็คได้ 2 วันย้อนหลัง ไม่ต้องกลัวตกหล่นเรื่องข้อมูลการแข่งทุกโปรแกรมบอล มาพร้อมเหตุการณ์ระหว่างเกมส์ รายชื่อผู้เล่นลงสนาม นักเตะที่สามารถทำประตูได้ จำนวนแอสซิส ใบเหลือง ใบแดง ในระหว่างการแข่ง และสถิติเชิงตัวเลขอย่าง อัตราการบุก จำนวนยิงเข้ากรอบ จำนวนครั้งที่ได้ยิงจุดโทษ การเปลี่ยนตัวนักเตะ เทียบระหว่างเจ้าบ้านและทีมเยือนให้เห็นกันชัดๆในเชิงสถิติคำนวนออกมาเป็นเปอร์เซ็นต์ ดูง่ายว่าทีมไหนครองเกมได้ดีกว่ากัน</p>
                  <p>เพราะเราเข้าใจความต้องการของกลุ่มคอบอลชาวไทย MVPKICK เลือกทำเว็บไซต์ ผลบอลสด ชื่อทีมเป็นภาษาไทย เมนูต่างๆจัดวางให้ผู้ใช้สามารถเลือกกดสลับหน้าดูข้อมูลสำคัญได้อย่างสะดวก ไม่หน่วง อัพเดทสกอร์บอลเรียลไทม์ตลอด 24 ชั่วโมงสำหรับหน้าผลบอลสดๆ และรายละเอียดข้อมูลอื่นๆในเรื่องฟุตบอลมีอยู่ครบเช่นกัน สามารถเลือกดูข้อมูลทีมโปรดของคุณได้เพียงคลิกที่ชื่อทีม ดูรายละเอียดการพบกันย้อนหลังของเจ้าถิ่นและผู้มาเยือน รวมถึงมาพร้อมบทวิเคราะห์บอลรายวันให้แฟนลูกหนังสายวิเคราะห์ได้คอยเกาะติดทุกวัน อ่านข่าวบอลรายวัน นำมาเทียบความน่าจะเป็นกับบทวิเคราะห์จากทางเว็บไซต์ รวมถึงลองดูสถิติย้อนหลังของรายการแข่งที่คุณสนใจ แล้วนำมาเป็นตัวช่วยตัดสินใจทำนายผลบอลล่วงหน้าเพื่อให้มีโอกาสแม่นยำมากขึ้น MVPKICK.COM เว็บเดียวมีครบเบ็ดเสร็จ</p>
               </div>
               </div>
        </div>
        </HelmetProvider>:
        <div>No Data</div>
        )
     }
}

export default Yesterday;